/**
 * patrol-evidence-search-view.js
 */

import React from 'react';
import IconSection from 'components/icon-section';
import InfoRow from 'components/info-row';
import PatrolArrestsBites from '../../helpers/patrol-arrests-bites-view';


export default function PatrolEvidenceSearchView(props) {
  const { 
    deployment,
    record,
  } = props;


  return (
    <>      
      <IconSection iconName='patrol-evidence-search'>

        {/* terrain types */}
        <InfoRow 
          title="Terrain Types" 
          text={record.evidenceSearch.types.map(type => type.customOtherName || type.name).join(', ')} 
        />

        {/* total area */}
        {record.evidenceSearch.areaSize !== null && record.evidenceSearch.areaSize > 0 && 
        <InfoRow 
          title="Total Area" 
          text={`${record.evidenceSearch.areaSize} ${record.evidenceSearch.areaSizeUnit?.name || ''}`} 
        />}

        {/* search duration */}
        <InfoRow
          title="Search Duration"
          text={`${record.evidenceSearch.searchDurationMinutes} minutes`}
        />

        {/* article description */}
        {record.evidenceSearch.articleDescription &&
        <InfoRow
          title="Article Description"
          text={record.evidenceSearch.articleDescription}
        />}

      </IconSection>

      <PatrolArrestsBites 
        deployment={deployment}
        record={record}
      />
    </>
  );
}